import { render, staticRenderFns } from "./SearchResultCard.vue?vue&type=template&id=3d4ed2b6&scoped=true"
import script from "./SearchResultCard.vue?vue&type=script&lang=js"
export * from "./SearchResultCard.vue?vue&type=script&lang=js"
import style0 from "./SearchResultCard.vue?vue&type=style&index=0&id=3d4ed2b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4ed2b6",
  null
  
)

export default component.exports